import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { registerSW } from 'virtual:pwa-register'
import { AppRouter } from './routes/index'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './components/offline/ToastProvider'
import './index.css'
import { ativarMaiusculoAutomatico } from './lib/maiusculo'

// Abas abertas (ex: TV Online, tela de lancamento de resultado) ficam presas
// no bundle antigo depois de um deploy — o service worker novo assume sozinho
// (registerType: 'autoUpdate') mas nao recarrega quem ja estava aberto. Sem
// isso, features novas (ex: campo de Penalidade) so aparecem apos um F5
// manual, o que passa despercebido durante um evento ao vivo.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  })
}
registerSW({ immediate: true })
ativarMaiusculoAutomatico()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 60, // 1 minuto
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <AppRouter />
          <ReactQueryDevtools initialIsOpen={false} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
